'use client';

import { c as _c } from "react/compiler-runtime";
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { cn } from '@/app/_lib/utils';
import type { JobOfferListItem } from '../../_data/types';
import { JobOfferList } from './JobOfferList';
export function JobOfferListAndContent(t0) {
  const $ = _c(21);
  const {
    jobOfferList,
    children
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("oferta");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isReadingJobOffer = Boolean(t1);
  const t2 = isReadingJobOffer ? "hidden lg:block" : "block";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("w-full lg:max-w-96", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LightCard className="flex-1 space-y-4 px-6"><div className="flex min-h-[20vh] items-center justify-center"><div>Ładowanie listy ofert pracy...</div></div></LightCard>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== jobOfferList) {
    t5 = <Suspense fallback={t4}><JobOfferList jobOfferList={jobOfferList} /></Suspense>;
    $[5] = jobOfferList;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = isReadingJobOffer ? "block" : "hidden lg:block";
  let t8;
  if ($[10] !== t7) {
    t8 = cn("min-w-0 flex-1", t7);
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isReadingJobOffer) {
    t9 = isReadingJobOffer && <><div className="flex items-center lg:hidden"><Link className="flex flex-row items-center gap-x-2" href="/kariera"><ArrowLeftIcon className="h-4 w-4 text-algoprimary" /><P3 className="font-semibold text-algoprimary">Powrót do ofert pracy</P3></Link></div><div className="lg:hidden"><VerticalSpacer size="content" /></div></>;
    $[12] = isReadingJobOffer;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== children || $[15] !== t8 || $[16] !== t9) {
    t10 = <div className={t8}>{t9}{children}</div>;
    $[14] = children;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t6) {
    t11 = <section className="mx-auto flex w-full flex-row gap-x-4 xl:gap-x-6">{t6}{t10}</section>;
    $[18] = t10;
    $[19] = t6;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}